import { Hud } from './components/Hud';
import { HoverTooltip, LevelUpModal, SleepOverlay, Toasts } from './components/Overlays';
import { ServicesContext, useServices, type Services } from './context';
import { AlmanacPanel } from './panels/AlmanacPanel';
import { FriendsPanel } from './panels/FriendsPanel';
import { MarketPanel } from './panels/MarketPanel';
import { HelpPanel, HousePanel, SettingsPanel } from './panels/MiscPanels';
import { OrdersPanel } from './panels/OrdersPanel';
import { openPanel, ui } from './store';

function TitleScreen() {
  const { startGame, hasSave, game } = useServices();
  const join = ui.pendingJoin.value;
  const start = (panel: 'friends' | 'help' | null) => {
    startGame();
    if (panel) openPanel(panel);
  };
  return (
    <div class="title-screen">
      <div class="title-card">
        <div class="title-flowers" aria-hidden="true">
          🌷🌼🌻🌸🌹
        </div>
        <h1>
          Petal <span>Plains</span>
        </h1>
        <p class="tagline">Grow, breed and sell flowers on a cosy prairie homestead.</p>
        <div class="title-buttons">
          {join ? (
            <button class="big-button" onClick={() => start('friends')} autoFocus>
              🧺 Visit farm {join}
            </button>
          ) : null}
          <button
            class={`big-button ${join ? 'secondary' : ''}`}
            onClick={() => start(hasSave ? null : 'help')}
            autoFocus={!join}
          >
            {hasSave ? `🌼 Continue · Day ${game.state.day}` : '🌱 Start farming'}
          </button>
          {!join && (
            <button class="big-button secondary" onClick={() => start('friends')}>
              👥 Play with friends
            </button>
          )}
        </div>
        <p class="title-foot">Click to play · progress saves automatically</p>
      </div>
    </div>
  );
}

function ActivePanel() {
  switch (ui.panel.value) {
    case 'market':
      return <MarketPanel />;
    case 'orders':
      return <OrdersPanel />;
    case 'almanac':
      return <AlmanacPanel />;
    case 'friends':
      return <FriendsPanel />;
    case 'settings':
      return <SettingsPanel />;
    case 'house':
      return <HousePanel />;
    case 'help':
      return <HelpPanel />;
    default:
      return null;
  }
}

export function App({ services }: { services: Services }) {
  return (
    <ServicesContext.Provider value={services}>
      {ui.started.value ? <Hud /> : <TitleScreen />}
      <Toasts />
      {ui.started.value && <ActivePanel />}
      <HoverTooltip />
      <LevelUpModal />
      <SleepOverlay />
    </ServicesContext.Provider>
  );
}
